import { apiDelete, apiGet, apiPatch, apiPost } from './client.js';

export interface TicketTemplateRepair {
  serviceId?: string;
  serviceName: string;
  quotedPrice: number;
  warrantyDays?: number;
  price?: number;
}

export interface TicketTemplate {
  id: string;
  name: string;
  makeId?: string | null;
  modelId?: string | null;
  makeName?: string | null;
  modelName?: string | null;
  repairs: TicketTemplateRepair[];
  defaultCondition: string;
  defaultWarrantyDays?: number | null;
  tags?: string[] | null;
  usageCount: number;
  active: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface AppliedTicketTemplate {
  id: string;
  name: string;
  makeId?: string | null;
  modelId?: string | null;
  makeName?: string | null;
  modelName?: string | null;
  defaultCondition: string;
  repairs: Array<{
    serviceId?: string;
    serviceName: string;
    quotedPrice: number;
    warrantyDays?: number;
  }>;
  defaultWarrantyDays?: number | null;
  tags: string[];
}

export interface CreateTicketTemplateBody {
  name: string;
  makeId?: string | null;
  modelId?: string | null;
  defaultCondition?: string;
  repairs: Array<{
    serviceId?: string;
    serviceName: string;
    quotedPrice: number;
    warrantyDays?: number;
  }>;
  defaultWarrantyDays?: number | null;
  tags?: string[];
  active?: boolean;
}

export function listTicketTemplates(params?: {
  makeId?: string;
  search?: string;
  sort?: 'usage' | 'name' | 'recent';
}) {
  return apiGet<TicketTemplate[]>('/api/v1/ticket-templates', { params }).then((res) => res.data);
}

export function createTicketTemplate(body: CreateTicketTemplateBody | Record<string, unknown>) {
  return apiPost<TicketTemplate, Record<string, unknown>>('/api/v1/ticket-templates', body).then(
    (res) => res.data,
  );
}

export function updateTicketTemplate(id: string, body: Record<string, unknown>) {
  return apiPatch<TicketTemplate, Record<string, unknown>>(`/api/v1/ticket-templates/${id}`, body).then(
    (res) => res.data,
  );
}

export function deleteTicketTemplate(id: string) {
  return apiDelete<unknown>(`/api/v1/ticket-templates/${id}`).then(() => undefined);
}

export function applyTicketTemplate(id: string) {
  return apiPost<AppliedTicketTemplate, undefined>(`/api/v1/ticket-templates/${id}/apply`).then(
    (res) => res.data,
  );
}
